<mat-spinner strokeWidth="10" [diameter]="100"></mat-spinner>
